var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _c("b-form-file", {
        staticClass: "upload-box text-nowrap text-truncate",
        attrs: {
          size: "lg",
          state: Boolean(_vm.uploadFiles),
          placeholder: "Choose or Drop file here",
          "drop-placeholder": "Drop file here",
          multiple: ""
        },
        on: {
          input: function($event) {
            return _vm.select()
          }
        },
        model: {
          value: _vm.uploadFiles,
          callback: function($$v) {
            _vm.uploadFiles = $$v
          },
          expression: "uploadFiles"
        }
      }),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.uploadFiles.length > 0
        ? _c("img", {
            staticStyle: { width: "30%" },
            attrs: { id: "file_upload", src: "#" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("p", { attrs: { id: "more" } }),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "uploading-box", class: { hidden: !_vm.loading } },
        [
          _c("div", {
            staticClass: "uploading-bar-green",
            style: "width:" + _vm.loadingBarWidth + "%",
            attrs: { id: "loading-progress" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          class: { hidden: _vm.uploading },
          attrs: { disabled: !_vm.ready },
          on: {
            click: function($event) {
              return _vm.upload()
            }
          }
        },
        [_vm._v("Upload")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "uploading-box", class: { hidden: !_vm.uploading } },
        [
          _c(
            "div",
            { staticClass: "uploading-bar", attrs: { id: "progress" } },
            [
              _c("p", {
                staticClass: "upload-text",
                attrs: { id: "progress-text" }
              })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Upload Document")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c3e0ce8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c3e0ce8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/add/Add_Documents.vue
// module id = 635
// module chunks = 0